// extracted by mini-css-extract-plugin
module.exports = {"marginSmall":"1rem","fullWidthFormContainer":"ForgotPassword_fullWidthFormContainer__33cWJ"};